export const en = {
    'block-description':
        'This is how users will see your ad. The more information you include, the more places your ad can appear.',
    'block-title': 'Ad preview',
    'go-to-link-btn': 'Click the link',
    'play-btn': 'Watch the video',
    'play-btn-audio': 'Listen to audio',
    'play-btn-common': 'Play',
    'play-btn-video': 'Watch the video'
};
